import { makeStyles } from "@material-ui/core";
import moment from "moment";

import { Card } from "../../../components/card/Card";
import { CardHeader } from "../../../components/card/CardHeader";
import { CardContent } from "../../../components/card";
import { OnboardingTaskDocument } from "../../../task/task.model";

const useStyles = makeStyles({
    group: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "24px",

        "&:last-child": {
            marginBottom: 0,
        },

        "& > label": {
            fontSize: "14px",
            fontWeight: 500,
            color: "#1C5B13",
            marginBottom: "4px",
        },

        "& > span": {
            fontSize: "16px",
            fontWeight: 400,
            color: "#4A4A4A",
            lineHeight: "125%",
            whiteSpace: "pre-wrap",
        },
    },
    order: {
        "& > *": {
            marginBottom: "16px",
        },

        "& > *:last-child": {
            marginBottom: 0,
        }
    },
});

interface ApplicationTaskDetailCardProps {
    task: OnboardingTaskDocument;
}

export const ApplicationTaskDetailCard = (props: ApplicationTaskDetailCardProps) => {
    const classes = useStyles();

    const { task } = props;

    return (
        <Card>
            <CardHeader>Ansøgning fra {task.gardenerName}</CardHeader>

            <CardContent className={classes.order}>

                <div className={classes.group}>
                    <label>Hvad er der hændt?</label>
                    <span>{task.gardenerName} har ansøgt om at blive havemand ved Go Go Garden.</span>
                </div>

                <div className={classes.group}>
                    <label>Hvad skal der gøres?</label>
                    <span>Besvar opgaven for at gennemgå ansøgningen.</span>
                </div>

                <div className={classes.group}>
                    <label>Hvornår skal det udføres?</label>
                    <span>{moment(task.performAfterDate).format("D MMMM YYYY HH:mm")}</span>
                </div>

            </CardContent>

        </Card>
    );
};
